import React from 'react';
import { Card, CardBody, Progress, UncontrolledTooltip } from 'reactstrap';

const PocketBaseStatus = ({ status = { status: 'checking' } }) => {
    const formatBytes = (bytes) => {
        if (!bytes || isNaN(bytes)) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    };

    const calculateStoragePercent = () => {
        if (!status?.totalStorageSize || !status?.usedStorageSize) return 0;
        const percent = Math.round((status.usedStorageSize / status.totalStorageSize) * 100);
        return isNaN(percent) ? 0 : percent;
    };

    const currentStatus = status?.status || 'checking';
    const isOnline = currentStatus === 'online';
    const storagePercent = calculateStoragePercent();

    return (
        <Card>
            <CardBody>
                <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                        <div className={`avatar-sm rounded bg-${isOnline ? 'success' : 'danger'}-subtle`}>
                            <div className="avatar-title rounded">
                                <i className={`ri-database-2-line text-${isOnline ? 'success' : 'danger'} fs-24`}></i>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 ms-3">
                        <div className="d-flex align-items-center">
                            <h4 className="fs-16 mb-0">PocketBase Server</h4>
                            <span className={`badge bg-${isOnline ? 'success' : 'danger'}-subtle text-${isOnline ? 'success' : 'danger'} fs-12 ms-2`}>
                                {currentStatus.toUpperCase()}
                            </span>
                        </div>

                        {/* Server URL */}
                        {status.baseUrl && (
                            <div className="mt-2">
                                <p className="text-muted mb-0 fs-12">
                                    <i className="ri-link me-1"></i>
                                    <a
                                        href={`${status.baseUrl}/_/`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-reset text-decoration-underline"
                                        id="pbAdminUrl"
                                    >
                                        {status.baseUrl}
                                    </a>
                                </p>
                                <UncontrolledTooltip placement="top" target="pbAdminUrl">
                                    PocketBase Admin Panel
                                </UncontrolledTooltip>
                            </div>
                        )}

                        {isOnline ? (
                            <>
                                <div className="mt-3">
                                    <p className="text-muted mb-0 fs-12">
                                        <i className="ri-time-line me-1"></i>
                                        Son kontrol: {new Date(status.lastChecked || Date.now()).toLocaleString('tr-TR')}
                                    </p>
                                </div>
                                {status.healthCheck && (
                                    <div className="mt-2">
                                        <p className="text-muted mb-0 fs-12">
                                            <i className="ri-heart-pulse-line me-1 text-success"></i>
                                            Server aktif
                                        </p>
                                    </div>
                                )}
                                
                                {/* Disk Usage */}
                                <div className="mt-3">
                                    <div className="d-flex align-items-center mb-2">
                                        <p className="text-muted mb-0 fs-12">Disk Kullanımı</p>
                                        <span className={`badge bg-${
                                            storagePercent > 90 ? 'danger' : 
                                            storagePercent > 70 ? 'warning' : 
                                            'success'}-subtle fs-12 ms-2`}
                                        >
                                            {storagePercent}%
                                        </span>
                                    </div>
                                    <Progress 
                                        value={storagePercent}
                                        color={storagePercent > 90 ? 'danger' : 
                                               storagePercent > 70 ? 'warning' : 
                                               'success'}
                                        className="mt-2"
                                    />
                                    <div className="d-flex justify-content-between mt-1">
                                        <small className="text-muted">
                                            {formatBytes(status.usedStorageSize)}
                                        </small>
                                        <small className="text-muted">
                                            {formatBytes(status.totalStorageSize)}
                                        </small>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="mt-2">
                                <p className="text-danger mb-0 fs-12">
                                    <i className="ri-error-warning-line me-1"></i>
                                    {status.message || 'Bağlantı hatası'}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default PocketBaseStatus;